// section_heading: a display-only group heading between fields — "The
// policy being replaced". No input, no answer; just the uppercase label
// the mockups put over each cluster of questions.

import React from "react";

import { RenderableField } from "./types";

export default function SectionHeadingField({
  field,
}: {
  field: RenderableField;
}) {
  return (
    <h2 className="-mb-2 pt-2 text-[13px] font-bold uppercase leading-normal tracking-[0.12em] text-oat-800">
      {field.title}
    </h2>
  );
}
